module.exports = __webpack_public_path__ + "static/media/signage-indoor-img6.5b58e53a.jpg";